"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const AppButton_vue_1 = require("@/client/components/common/AppButton.vue");
const UndergroundToken_vue_1 = require("@/client/components/underworld/UndergroundToken.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'SelectClaimedUndergroundToken',
    props: {
        playerView: {
            type: Object,
            required: true,
        },
        playerinput: {
            type: Object,
            required: true,
        },
        onsave: {
            type: Function,
            required: true,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data() {
        return {
            selected: [],
        };
    },
    components: {
        AppButton: AppButton_vue_1.default,
        UndergroundToken: UndergroundToken_vue_1.default,
    },
    methods: {
        canSave() {
            if (this.selected.length > this.playerinput.max) {
                return false;
            }
            if (this.selected.length < this.playerinput.min) {
                return false;
            }
            return true;
        },
        saveData() {
            this.onsave({ type: 'claimedUndergroundToken', selected: this.selected.sort() });
        },
    },
});
